import './scss/sketchfab-viewer.scss';
import './scss/colour-picker.scss';
import SketchfabViewer from './sketchfabViewer';
import ColorPicker from './colorPicker';

export default class Sketchfab360Viewer {
    constructor(el) {
        this.el = el;
        this.colorSwatches = el.querySelectorAll('.variant-color');
        this.sketchfabViewer = new SketchfabViewer({ colorSwatches: this.colorSwatches, parentElement: this.el });
        this.colorPicked = new ColorPicker({ colorSwatches: this.colorSwatches, parentElement: this.el });
    }
}
